export default {
    //比如控制按钮登根据权限显示:<Button v-perm:userAdd></Button>
    perm:{
        inserted: function (el, binding, vNode) {
            var perms = [];//按钮权限集合
            if (perms.length == 0) return;
           
            var per = binding.arg;
            if (perms.indexOf(per) === -1) {
                // el.disabled = 'disabled'
                // el.classList.add('is-disabled');
            }
        }
    }
}